import StopIcon from '@material-ui/icons/Stop';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stopConferenceSessionAction } from 'store/conference/conferenceActions';
import DefaultIcon from './DefaultIcon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import useTheme from '@material-ui/styles/useTheme';

export default function StopStream() {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { Status } = useSelector(({ conference }) => ({
    Status: conference.Status,
  }));
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Stop Session Stream'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            By Clicking Stop Stream, This Will End The Stream For All Users. The Attendees Will No
            Longer See Anything In This Session.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              dispatch(stopConferenceSessionAction());
              handleClose();
            }}
            style={{ backgroundColor: theme.palette.danger.main, color: 'white' }}
            autoFocus
          >
            Stop Stream
          </Button>
        </DialogActions>
      </Dialog>

      <DefaultIcon
        name="Stop"
        IconComp={StopIcon}
        hideIcon={Status !== 'LIVE'}
        shouldPopout={false}
        handleClick={() => {
          handleClickOpen();
        }}
      />
    </>
  );
}
